// extracted by mini-css-extract-plugin
module.exports = {"button__makeOrder":"FooterMiniCart_button__makeOrder__Udham","button__primary":"FooterMiniCart_button__primary__B2HiW"};